import React from "react";

import { createStyles, palette } from "../../../../styles/theme";
import { getConditionnalStyle } from "../../../../utils/themeUtils";
import { Box } from "../../Box";
import { DarkTooltip } from "../../DarkTooltip";

const styles = createStyles({
  container: {
    border: "2px solid transparent",
    borderRadius: "50%",
    cursor: "pointer",
  },
  selected: {
    padding: "1px",
    border: "2px solid #3f70aa",
  },
  color: {
    borderRadius: "50%",
    width: 15,
    height: 15,
  },
  white: {
    border: `1px solid ${palette.grey.midGrey}`,
  },
});

interface Props {
  color: string;
  png?: string;
  isSelected: boolean;
  tooltip: string;
}

export const MicroColorCircle = ({
  color = "#000000",
  png,
  isSelected,
  tooltip,
}: Props) => {
  return (
    <React.Fragment>
      <DarkTooltip title={tooltip ? tooltip : ""} followCursor>
        <Box
          sx={[
            styles.container,
            getConditionnalStyle(isSelected, styles.selected),
            getConditionnalStyle(color === "#FFFFFF" && !isSelected, {
              border: `1px solid ${palette.grey.midGrey}`,
            }),
          ]}
        >
          {png ? (
            <img src={png} style={styles.color} alt="color" />
          ) : (
            <Box
              sx={{
                ...styles.color,
                backgroundColor: color,
              }}
            />
          )}
        </Box>
      </DarkTooltip>
    </React.Fragment>
  );
};
